import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Icon, LoadingCircle } from '../Icon';
import { Image } from '../Image';
import { VideoPlayer } from '../VideoPlayer';
import styles from './index.module.less';
export const MediaViewer = ({ name, image, animationUrl, ...rest }) => {
    const mediaUrl = image || animationUrl || '';
    const ref = useRef(null);
    return (_jsx("div", { ...rest, ref: ref, children: mediaUrl.match(/\.mp4$/i) ? (_jsx(VideoPlayer, { className: styles.videoPlayer, src: mediaUrl, alt: name, height: "100%" })) : (_jsx(Image, { className: styles.image, loading: "lazy", src: image, alt: name, height: "100%", alternative: _jsx(Icon, { type: "mask", size: 48 }) })) }));
};
export const MockViewer = (props) => {
    return (_jsxs("div", { ...props, children: [_jsx(Icon, { type: "mask", size: 48 }), ";"] }));
};
export const MediaViewerSkeleton = (props) => {
    return (_jsx("div", { ...props, children: _jsx(LoadingCircle, {}) }));
};
